"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMetaValueFromKey = void 0;
const getMetaValueFromKey = (meta, key) => {
    return meta?.find((meta) => meta.key === key)?.value;
};
exports.getMetaValueFromKey = getMetaValueFromKey;
